import React, { useState } from 'react';
import '../styles/features.css';

const Features = () => {
  const [activeCard, setActiveCard] = useState(null);

  const toggleInfo = (id) => {
    setActiveCard(activeCard === id ? null : id);
  };

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const features = [
    {
      id: 'legal',
      icon: 'bi-briefcase',
      title: 'Strategische Rechtsberatung für Unternehmen',
      subtitle: 'Beratung in allen Phasen Ihres Unternehmens',
      description:
        'Von der Gründung über das Wachstum bis zur Optimierung beraten wir Sie in allen Phasen Ihres Unternehmens. \n Dazu gehören die Gestaltung von Gesellschaftsverträgen, die Prüfung von Handels- und Lieferverträgen sowie die rechtliche Absicherung Ihrer täglichen Geschäfts- entscheidungen.\n\nUnser Ansatz geht über die reine Rechtsberatung hinaus: \n Wir unterstützen Sie auch bei der strategischen Weiterentwicklung, beim Aufbau solider Corporate-Governance-Strukturen und im Risikomanagement – damit Ihr Unternehmen für die Zukunft sicher aufgestellt ist.',
      items: []
    },
    {
      id: 'digital-law',
      icon: 'bi-laptop',
      title: 'IT-Recht & Compliance',
      subtitle: 'Rechtssicherheit für digitale Geschäftsmodelle',
      description:
        'Wir schaffen rechtliche Klarheit für Ihre digitalen Produkte und Dienstleistungen. Das umfasst die Gestaltung und Prüfung komplexer IT-Verträge wie SaaS-, Lizenz- und Service-Level-Agreements sowie die Erstellung rechtssicherer Allgemeiner Geschäftsbedingungen (AGB) für Ihren Online-Auftritt und weitere Themenfelder.\nZudem navigieren wir Ihr Unternehmen sicher durch die regulatorische Landschaft. Wir beraten Sie proaktiv zu den Anforderungen der EU-Digitalgesetze – etwa DSGVO, DORA oder AI Act – damit Ihr Geschäftsmodell nicht nur heute, sondern auch zukünftig auf einem soliden rechtlichen Fundament steht.',
      items: []
    },
    {
      id: 'civil-law',
      icon: 'bi-person-badge',
      title: 'Allgemeines Zivilrecht & Prozessführung',
      subtitle: 'Individuelle Vertretung Ihrer Interessen',
      description:
        'Als überzeugte Zivilrechtler sind wir Ihr starker Partner für private Rechtsangelegenheiten. Unsere Tätigkeiten umfassen den gesamten Bereich der Interessenvertretung:\n\nBeratend: Wir geben Ihnen eine klare und ehrliche Einschätzung Ihrer rechtlichen Position.\nGestaltend: Wir entwerfen und prüfe Verträge, um zukünftige Konflikte zu vermeiden.\nProzessual: Wir setzen Ihre Ansprüche konsequent vor Gericht durch und verteidige Sie gegen unberechtigte Forderungen.',
      items: []
    }
  ];

  return (
    <section id="features" className="features-section py-5 bg-white">
      <div className="container text-center">
        <h2 className="display-5 fw-bold mb-4">Unsere Leistungen</h2>
        <div className="row flex-nowrap overflow-auto" id="feature-cards-container">
          {features.map((feature) => (
            <div key={feature.id} className="col-md-4 mb-4 feature-card h-100">
              <div className="card border-0 shadow-sm h-100">
                <div
                  className="card-body"
                  onClick={() => toggleInfo(feature.id)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="icon-container mb-3">
                    <i className={`bi ${feature.icon}`} style={{ fontSize: '40px', color: '#555' }}></i>
                  </div>
                  <h5 className="card-title">{feature.title}</h5>
                  <p className="card-text text-muted">{feature.subtitle}</p>
                </div>
                <div className={`collapse ${activeCard === feature.id ? 'show' : ''} text-start px-3 pb-3`} id={feature.id}>
                  {feature.description.split('\n').map((line, idx) => (
                    <p key={idx} className="mb-2">{line}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-4 lead">
          Ihr Anliegen ist hier nicht dabei? <br />
          <button
            className="btn btn-link p-0 align-baseline"
            onClick={() => scrollToSection('kontakt')}
          >
            Kontaktieren Sie uns für eine individuelle Einschätzung.
          </button>
        </p>
      </div>
    </section>
  );
};

export default Features;
